export default __webpack_public_path__ + "static/media/prevIcon.db959aaf.svg";